<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="cargandoFotos" :can-cancel="false"></b-loading>
    <section class="section section-subir-fotos">
      <div class="container">
        <!-- WIZARD PARA PASO A PASO -->
        <form-wizard
          :nextButtonText="wizard.textoBotonSig"
          :backButtonText="wizard.textoBotonAnterior"
          :finishButtonText="wizard.textoBotonFinalizar"
          :color="wizard.color"
          :errorColor="wizard.errorColor"
          @on-complete="iniciarSubida"
          shape="square"
          id="titulo-subir-fotos"
        >
          <template v-slot:title>
            <TitleSlot
              :tipoSubida="tipoSubida"
              :packFoto="packFoto"
              :oferta="oferta"
              id="titulo-subir-fotos"
            />
          </template>
          <template v-slot:next>
            <b-button
              type="is-primary"
              icon-right="arrow-right-bold-box-outline"
              size="is-medium"
            >Siguiente</b-button>
          </template>

          <template v-slot:prev>
            <b-button
              type="is-primary"
              icon-left="arrow-left-bold-box-outline"
              size="is-medium"
            >Anterior</b-button>
          </template>

          <template v-slot:finish>
            <b-button
              type="is-success"
              icon-right="arrow-up-bold-box-outline"
              size="is-medium"
            >Subir Pedido</b-button>
          </template>

          <!-- CONFIGURACION DE PEDIDO -->
          <tab-content
            icon="ti-settings"
            v-if="tipoUsuario === this.$constantes.usuarios.tipos.AFICIONADO"
            :title="wizard.tipoEntrega ? `Modo de envío: ${wizard.tipoEntrega}` : `Modo de envío`"
            :beforeChange="validacionTabConfiguracion"
          >
            <div class="columns is-centered is-multiline">
              <div class="column is-4">
                <b-field
                  label="Entrega"
                  :type="{'is-danger': errors.has('tipo entrega')}"
                  :message="errors.first('tipo entrega')"
                >
                  <b-select
                    required
                    v-model="wizard.tipoEntrega"
                    name="tipo entrega"
                    v-validate="'required'"
                    expanded
                    @input="onChangeTipoEntrega"
                  >
                    <option value>Seleccionar</option>
                    <option
                      v-for="(tipoEntrega, index) of this.$constantes.pedidos.tiposEntrega"
                      :key="'tipoE-'+index"
                      :value="tipoEntrega.texto"
                    >{{tipoEntrega.texto}}</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-12">
                <b-message type="is-info is-hidden-mobile">
                  <template v-for="(tipoEntrega, index) of this.$constantes.pedidos.tiposEntrega">
                    <p :key="'tipoEDesc-'+index">
                      <strong>{{ tipoEntrega.texto }}</strong>
                      : {{tipoEntrega.descripcion}}
                    </p>
                  </template>
                </b-message>
              </div>
            </div>
          </tab-content>

          <!-- CARGA DE LAS FOTOS -->
          <tab-content
            title="Selección de fotos"
            :beforeChange="validacionTabFotos"
            icon="ti-image"
          >
            <div class="columns is-multiline">
              <DropTargetFotos v-show="!cargandoFotos" />
              <ProgresoSubida v-if="cargandoFotos" :uploader="uploader" />
              <div
                class="column is-12"
                v-if="wizard.tipoEntrega === this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto
                      && !sinEnvioGratis && !cargandoFotos && cantidadFotosSeleccionadas > 0"
              >
                <b-notification
                  :closable="false"
                  :type="wizard.notificacionEnvioGratis.type"
                  has-icon
                >{{ wizard.notificacionEnvioGratis.message }}</b-notification>
              </div>
              <div class="column is-12">
                <b-switch
                  class="switch-previsualizacion"
                  v-model="previewImagenesHabilitado"
                  v-if="cantidadFotosSeleccionadas > 0">
                    {{ previewImagenesHabilitado ? `Deshabilitar Previsualización` : 'Habilitar Previsualización' }}
                </b-switch>
                <BoxFotos
                    v-on:eliminar-foto="eliminarFoto"
                    :uploader="uploader"
                    :tablaFotos="tablaFotos"
                    :cantidadFotosSeleccionadas="cantidadFotosSeleccionadas"
                    v-show="!previewImagenesHabilitado"
                  />
                <BoxFotosPreview
                    v-on:eliminar-foto="eliminarFoto"
                    :uploader="uploader"
                    :tablaFotos="tablaFotos"
                    :cantidadFotosSeleccionadas="cantidadFotosSeleccionadas"
                    v-show="previewImagenesHabilitado"
                  />
                <template v-if="cantidadFotosSeleccionadas > 0">
                  <b-field label="Observaciones">
                    <b-input maxlength="2000" v-model="wizard.observaciones" type="textarea"></b-input>
                  </b-field>
                  <nav class="level">
                    <div class="level-item has-text-centered" v-if="cantidadFotosSeleccionadas > 0">
                      <div>
                        <p class="heading">Tamaño total</p>
                        <p
                          class="title is-4"
                        >{{parseFloat(uploader.total.size / 1024 / 1024).toFixed(2)}} MB</p>
                      </div>
                    </div>
                    <div
                      class="level-item has-text-centered"
                      v-if="tipoUsuario === this.$constantes.usuarios.tipos.AFICIONADO"
                    >
                      <div>
                        <p class="heading">
                          Precio
                          <small
                            v-if="wizard.tipoEntrega !== $constantes.pedidos.tiposEntrega.RETIRO_LOCAL.texto"
                          >(sin envío)</small>
                        </p>
                        <p class="title is-4">{{ precio }}</p>
                      </div>
                    </div>
                    <div
                      class="level-item has-text-centered"
                      v-if="wizard.tipoEntrega === this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto"
                    >
                      <div>
                        <p class="heading">Precio Envio</p>
                        <p class="title is-4" v-if="mostrarPrecioEnvio">${{wizard.cadete.precio}}</p>
                        <p class="title is-4 has-text-info" v-else>¡GRATIS!</p>
                      </div>
                    </div>
                    <div class="level-item has-text-centered" v-if="cantidadFotosSeleccionadas > 0">
                      <div>
                        <p class="heading">Fotos Seleccionadas</p>
                        <b-tooltip
                          label="Límite Excedido"
                          position="is-right"
                          type="is-warning"
                          :active="cantidadMaximaExcedida"
                          always
                        >
                          <p class="title is-4">{{cantidadDeFotosAMostrarEnContador}}</p>
                        </b-tooltip>
                      </div>
                    </div>
                  </nav>
                </template>

                <div class="columns is-multiline">
                  <div class="column is-4" v-if="cantidadFotosSeleccionadas > 0">
                    <b-button
                      class="is-fullwidth"
                      type="is-danger"
                      v-on:click="eliminarFotos()"
                      icon-left="trash-can-outline"
                    >Eliminar Todas</b-button>
                  </div>
                </div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </div>
    </section>
    <Promo />
  </div>
</template>

<style>
.section-subir-fotos {
  margin-top: 2.8rem;
}
.switch-previsualizacion{
  margin-bottom: 1rem;
}
</style>

<script>
import BoxFotos from '@/components/SubirFotos/BoxFotos.vue'
import BoxFotosPreview from '@/components/SubirFotos/BoxFotosCard.vue'
import ProgresoSubida from '@/components/SubirFotos/ProgresoSubida.vue'
import DropTargetFotos from '@/components/SubirFotos/DropTargetFotos.vue'
import TitleSlot from '@/components/SubirFotos/TitleSlot.vue'
import Promo from '@/components/Promo.vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  name: 'SubirFotosIndex',
  props: {
    packFoto: {
      type: Object
    },
    oferta: {
      type: Object
    }
  },
  components: {
    Promo,
    FormWizard,
    TabContent,
    BoxFotos,
    BoxFotosPreview,
    ProgresoSubida,
    DropTargetFotos,
    TitleSlot
  },
  data () {
    return {
      titulo: 'Subir Fotos',
      subtitulo: 'Subí tus fotos a nuestra plataforma',
      tipoUsuario: null,
      cantidadFotosSeleccionadas: 0,
      previewImagenesHabilitado: true,
      wizard: {
        tituloWizard: 'Subí tus fotos',
        color: '#00CEDB',
        errorColor: '#FF151F',
        textoBotonAnterior: 'Anterior',
        textoBotonSig: 'Siguiente',
        textoBotonFinalizar: 'Subir Fotos',
        tipoEntrega: null, // Selector para el tipo de entrega, si es que se utiliza compra online
        observaciones: '',
        notificacionEnvioGratis: {
          active: false,
          message: '',
          type: ''
        }
      },
      tablaFotos: {
        isPaginated: true, // Paginado de la lista de fotos
        isPaginationSimple: false, // Paginado simple o con numeración
        defaultSortDirection: 'asc', // Direccion del ordenamiento en la tabla
        currentPage: 1, // Pagina actual para la tabla
        isHoverable: true, // Hover habilitado sobre filas
        perPage: 10, // Items a mostrar por pagina
        isNarrowed: true, // Propiedad narrowed de la tabla (especifico buefy)
        hasMobileCards: true // Indica si en mobile se deben mostrar tarjetas en vez de la tabla
      },
      window: {
        width: 0,
        height: 0
      },
      archivosErroneos: [],
      cargandoFotos: false, // Boolean para identificar si se está activo el proceso de subida de fotos
      uploader: {}, // Almacena el uploader de plupload
      idPedidoCreado: null
    }
  },
  computed: {
    cantidadDeFotosAMostrarEnContador () {
      let cantidadAMostrar = this.cantidadFotosSeleccionadas
      switch (this.tipoSubida) {
        case this.$constantes.tiposSubida.PACK_FOTO:
          // Para el caso del tipoPackFoto fijo, la cantidad minima representa la cantidad exacta que debe tener el pedido
          if (
            this.packFoto.oferta.tipoPackFoto ===
            this.$constantes.ofertas.tiposPackFotos.FIJO
          ) {
            cantidadAMostrar += ` / ${this.packFoto.cantidadMinFotos}`
          } else {
            cantidadAMostrar += ` / ${this.packFoto.cantidadMaxFotos}`
          }
          break
        case this.$constantes.tiposSubida.OFERTA:
          break
      }
      return cantidadAMostrar
    },
    cantidadMaximaExcedida () {
      let cantidadMaximaExcedida = false
      switch (this.tipoSubida) {
        case this.$constantes.tiposSubida.PACK_FOTO:
          // Para el caso del tipoPackFoto fijo, la cantidad minima representa la cantidad exacta que debe tener el pedido
          if (
            this.packFoto.oferta.tipoPackFoto ===
            this.$constantes.ofertas.tiposPackFotos.FIJO
          ) {
            cantidadMaximaExcedida =
              this.cantidadFotosSeleccionadas > this.packFoto.cantidadMinFotos
          } else {
            cantidadMaximaExcedida =
              this.cantidadFotosSeleccionadas > this.packFoto.cantidadMaxFotos
          }
          break
        case this.$constantes.tiposSubida.OFERTA:
          break
      }
      return cantidadMaximaExcedida
    },
    cantidadMinimaNoAlcanzada () {
      let cantidadMinimaNoAlcanzada = false
      switch (this.tipoSubida) {
        case this.$constantes.tiposSubida.PACK_FOTO:
          // Para el caso del tipoPackFoto fijo, la cantidad minima representa la cantidad exacta que debe tener el pedido
          if (
            this.packFoto.oferta.tipoPackFoto ===
            this.$constantes.ofertas.tiposPackFotos.FIJO
          ) {
            cantidadMinimaNoAlcanzada =
              this.cantidadFotosSeleccionadas < this.packFoto.cantidadMinFotos
          } else {
            cantidadMinimaNoAlcanzada =
              this.cantidadFotosSeleccionadas < this.packFoto.cantidadMinFotos
          }
          break
        case this.$constantes.tiposSubida.OFERTA:
          break
      }
      return cantidadMinimaNoAlcanzada
    },
    precio () {
      let precioString = ''
      switch (this.tipoUsuario) {
        // Si es tipo profesional, no se muestra precio
        case this.$constantes.usuarios.tipos.PROFESIONAL:
          break
        // Si es aficionado, se muestra precio depende el tipo de subida
        case this.$constantes.usuarios.tipos.AFICIONADO:
          switch (this.tipoSubida) {
            case this.$constantes.tiposSubida.OFERTA: // Si es del tipo OFERTA, es porque es dinamico el pedido, asi que se calcula por unidad
              if (this.packFotoSeleccionado) {
                precioString = `$${this.packFotoSeleccionado.precio} x ${
                  this.cantidadFotosSeleccionadas
                } = $${this.packFotoSeleccionado.precio *
                  this.cantidadFotosSeleccionadas}`
              }
              break
            case this.$constantes.tiposSubida.PACK_FOTO: // Si es del tipo de PACK FOTO, puede ser por unidad o fijo
              // La unica posibilidad de que el precio sea por unidad, es que la oferta sea MIN MAX POR UNIDAD
              if (
                this.packFoto.oferta.tipoPackFoto ===
                this.$constantes.ofertas.tiposPackFotos.MIN_MAX_POR_UNIDAD
              ) {
                // El MIN MAX POR UNIDAD es el unico tipo Pack foto que el precio no es fijo
                precioString = `$${this.packFoto.precio} x ${
                  this.cantidadFotosSeleccionadas
                } = $${this.packFoto.precio * this.cantidadFotosSeleccionadas}`
              } else {
                // Si no, el precio eso fijo
                precioString = `$${this.packFoto.precio}`
              }
              break
          }
          break
        default:
          break
      }
      return precioString
    },
    tipoSubida () {
      return this.packFoto
        ? this.$constantes.tiposSubida.PACK_FOTO
        : this.$constantes.tiposSubida.OFERTA
    },
    packFotoSeleccionado () {
      // Solo hace el calculo del pack seleccionado si el tipo de subida es oferta (tipoPackFoto DINAMICO), sino no debe considerarse
      if (this.tipoSubida === this.$constantes.tiposSubida.OFERTA) {
        let packSeleccionado = null
        for (let i = 0; i < this.oferta.packFotosHabilitados.length; i++) {
          if (
            this.cantidadFotosSeleccionadas >=
            this.oferta.packFotosHabilitados[i].cantidadMinFotos
          ) {
            packSeleccionado = this.oferta.packFotosHabilitados[i]
          }
        }
        return packSeleccionado
      } else {
        return this.packFoto
      }
    },
    envioGratisCualquierCantidad () {
      if (
        this.wizard.tipoEntrega ===
          this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto &&
        this.packFotoSeleccionado &&
        this.packFotoSeleccionado.cantidadParaCadeteGratis === 0
      ) {
        return true
      } else {
        return false
      }
    },
    envioGratisCantidadEspecifica () {
      if (
        this.wizard.tipoEntrega ===
          this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto &&
        this.packFotoSeleccionado &&
        this.packFotoSeleccionado.cantidadParaCadeteGratis > 0
      ) {
        return true
      } else {
        return false
      }
    },
    envioGratisCantidadEspecificaLimiteAlcanzado () {
      if (
        this.wizard.tipoEntrega ===
          this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto &&
        this.packFotoSeleccionado &&
        this.packFotoSeleccionado.cantidadParaCadeteGratis > 0 &&
        this.cantidadFotosSeleccionadas >=
          this.packFotoSeleccionado.cantidadParaCadeteGratis
      ) {
        return true
      } else {
        return false
      }
    },
    sinEnvioGratis () {
      if (
        this.wizard.tipoEntrega ===
          this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto &&
        this.packFotoSeleccionado &&
        this.packFotoSeleccionado.cantidadParaCadeteGratis < 0
      ) {
        return true
      } else {
        return false
      }
    },
    mostrarPrecioEnvio () {
      if (this.sinEnvioGratis) {
        return true
      } else {
        if (this.envioGratisCualquierCantidad) {
          return false
        } else if (
          this.envioGratisCantidadEspecifica &&
          this.envioGratisCantidadEspecificaLimiteAlcanzado
        ) {
          return false
        } else {
          return true
        }
      }
    }
  },
  methods: {
    onChangeTipoEntrega () {
      // Se agrega listener por si se carga en alguna opcion que no sea envio parana y luego
      // se vuelve a elegir esa otra opcion
      this.evaluarNotificacionEnvioGratis(this.uploader)
    },
    evaluarNotificacionEnvioGratis (uploader) {
      // Si el timpo de operacion es compra online y el tipo de entrega es envio_domicilio
      // se agregan notificaciones para envio gratis
      if (
        this.tipoUsuario === this.$constantes.usuarios.tipos.AFICIONADO &&
        this.wizard.tipoEntrega ===
          this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto &&
        uploader.files.length > 0
      ) {
        this.wizard.notificacionEnvioGratis.type = 'is-success'
        this.wizard.notificacionEnvioGratis.message = ''

        if (this.envioGratisCualquierCantidad) {
          this.wizard.notificacionEnvioGratis.message =
            '¡Envío Gratis!'
        } else if (
          this.envioGratisCantidadEspecifica &&
          this.envioGratisCantidadEspecificaLimiteAlcanzado
        ) {
          this.wizard.notificacionEnvioGratis.message =
            '¡Envío Gratis!'
        } else if (
          this.envioGratisCantidadEspecifica &&
          !this.envioGratisCantidadEspecificaLimiteAlcanzado
        ) {
          this.wizard.notificacionEnvioGratis.type = 'is-info'
          this.wizard.notificacionEnvioGratis.message =
            this.packFotoSeleccionado.cantidadParaCadeteGratis -
              this.cantidadFotosSeleccionadas >
            1
              ? `¡${this.packFotoSeleccionado
                  .cantidadParaCadeteGratis -
                  this
                    .cantidadFotosSeleccionadas} fotos más para Envío Gratis!`
              : `¡${this.packFotoSeleccionado
                  .cantidadParaCadeteGratis -
                  this
                    .cantidadFotosSeleccionadas} foto más para Envío Gratis!`
        }

        this.$buefy.notification.open({
          duration: 2000,
          message: this.wizard.notificacionEnvioGratis.message,
          position: 'is-top',
          type: this.wizard.notificacionEnvioGratis.type,
          hasIcon: true
        })
      }
    },
    uploadComplete () {
      const componenteVue = this

      // Si hubo errores en envios
      if (this.archivosErroneos.length > 0) {
        componenteVue.$buefy.dialog.alert({
          title: 'Error',
          message: `Algunos archivos generaron error, te pedimos por favor que lo intentes nuevamente. Posiblemente tu conexión de internet es inestable. Si el problema persiste comunicate a <strong>${process.env.VUE_APP_MAIL_CONTACTO}</strong> e indica: 'ERROR EN SUBIDA DE FOTOS'`,
          type: 'is-danger',
          hasIcon: true,
          icon: 'close-circle-outline',
          iconPack: 'mdi',
          onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
        })
      } else {
        // Si no hubo errores

        let tipoPedido = ''
        switch (this.tipoUsuario) {
          // En el caso que sea profesional, el pedido es tradicional
          case this.$constantes.usuarios.tipos.PROFESIONAL:
            tipoPedido = this.$constantes.pedidos.tipos.TRADICIONAL
              .textoEntidad
            break
          // En el caso que sea aficionado, el pedido dependera del tipo de entrega
          case this.$constantes.usuarios.tipos.AFICIONADO:
            switch (this.wizard.tipoEntrega) {
              case this.$constantes.pedidos.tiposEntrega.RETIRO_LOCAL.texto:
                tipoPedido = this.$constantes.pedidos.tipos.COMPRA_ONLINE
                  .textoEntidad
                break
              case this.$constantes.pedidos.tiposEntrega.ENVIO_RESTO_DEL_PAIS
                .texto:
                tipoPedido = this.$constantes.pedidos.tipos
                  .COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad
                break
              case this.$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto:
                tipoPedido = this.$constantes.pedidos.tipos
                  .COMPRA_ONLINE_CON_ENVIO.textoEntidad
                break
            }
            break
        }

        componenteVue.$apiService
          .procesarPedido(
            componenteVue.idPedidoCreado,
            componenteVue.wizard.observaciones,
            componenteVue.cantidadFotosSeleccionadas,
            tipoPedido,
            // Depende de si el packFoto esta seteado o no, se envia el id del parametro principal o del calculado
            componenteVue.packFoto
              ? componenteVue.packFoto.id
              : componenteVue.packFotoSeleccionado.id
          )
          .then(response => {
            // Mostrar mensaje pedido correcto
            if (
              this.tipoUsuario === this.$constantes.usuarios.tipos.PROFESIONAL
            ) {
              // Termina la carga
              componenteVue.cargandoFotos = false
              componenteVue.$router.push({
                name: 'pedido-estado',
                params: { id: componenteVue.idPedidoCreado }
              })
              this.$buefy.dialog.alert({
                title: 'Listo',
                message: 'Tu pedido ha sido procesado correctamente',
                type: 'is-success',
                hasIcon: true
              })
            } else {
              // Muestra un mensaje
              componenteVue.$buefy.toast.open({
                duration: 10000,
                message: 'Pedido subido correctamente, redirigiendo',
                position: 'is-top',
                type: 'is-success'
              })

              // Termina la carga
              window.location = response.data.init_point
            }
          })
          .catch(error => {
            // Termina la carga
            componenteVue.cargandoFotos = false

            componenteVue.$buefy.dialog.alert({
              title: 'Error',
              message: `Se produjo un error inesperado en la subida, te pedimos por favor que lo intentes nuevamente. Si el problema persiste comunicate a <strong>${process.env.VUE_APP_MAIL_CONTACTO}</strong> e indica: 'ERROR EN PROCESAMIENTO DE FOTOS'`,
              type: 'is-danger',
              hasIcon: true,
              icon: 'close-circle-outline',
              iconPack: 'mdi',
              onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
            })
            componenteVue.handleUnexpectedError(error)
          })

        // Elimina las fotos de la lista plupload
        componenteVue.uploader.splice()
      }
    },
    controlarVencimientoToken () {
      if (
        this.$apiService.tokenVenceEnMenosDeHs(
          process.env.VUE_APP_HORAS_MINIMAS_PARA_SUBIDA
        )
      ) {
        this.$buefy.dialog.alert({
          title: 'Información',
          message:
            'Para prevenir una posible demora que interrumpa la subida, te solicitamos que inicies sesión nuevamente',
          type: 'is-warning',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        })
        this.$router.push({ name: 'login' })
      }
    },
    // Inicia la subida
    iniciarSubida () {
      // Antes de iniciar subida controla que el token no llege a vencerse antes del parametro
      if (
        this.$apiService.tokenVenceEnMenosDeHs(
          process.env.VUE_APP_HORAS_MINIMAS_PARA_SUBIDA
        )
      ) {
        this.$buefy.dialog.alert({
          title: 'Información',
          message:
            'Para prevenir una posible demora que interrumpa la subida, te solicitamos que inicies sesión nuevamente',
          type: 'is-warning',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        })
        this.$router.push({ name: 'login' }) // Redirige a login
      } else {
        // Sube hasta arriba de la vista
        document.getElementById('titulo-subir-fotos').scrollIntoView()
        // Inicia subida
        this.uploader.start()
        // Boolean para loading y progress
        this.cargandoFotos = true
      }
    },
    // Elimina una foto a partir de su id
    eliminarFoto (data) {
      // Elimina la foto con dicho id
      this.uploader.removeFile(data.id, data.nombre)
      // MUestra un mensaje
      this.$buefy.toast.open({
        duration: 1500,
        message: 'Eliminaste la foto ' + data.nombre,
        type: 'is-danger'
      })
    },
    // Elimina todas las fotos
    eliminarFotos () {
      const vueModel = this
      this.$buefy.dialog.confirm({
        title: 'Eliminar Fotos',
        message:
          '¿Estás seguro que querés <b>eliminar</b> todas las fotos? Esta acción no puede deshacerse.',
        confirmText: 'Vaciar Pedido',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vueModel.uploader.splice()
          vueModel.$buefy.toast.open({
            duration: 1000,
            message: 'Eliminaste todas las fotos',
            type: 'is-danger'
          })
        }
      })
      // Elimina las fotos de la lista plupload
    },
    generarToken () {
      const maxInt = 2147483647
      return Math.floor(Math.random() * (maxInt * 2) + 1 - maxInt)
    },
    // Deja continuar solo se validan todos los input
    async validacionTabConfiguracion () {
      // Espera por validacion asincrona
      const resultadoValidacion = await this.$validator.validate()
      if (!resultadoValidacion) {
        // Si hay errores, genera una lista con los mensajes y los muestra en un dialog
        let message = '<ul>'
        for (let i = 0; i < this.errors.items.length; i++) {
          message += '<li>' + this.errors.items[i].msg + '</li>'
        }
        message += '</u>'

        this.$buefy.dialog.alert({
          title: 'Error',
          message,
          type: 'is-danger',
          hasIcon: true,
          icon: 'close-circle-outline',
          iconPack: 'mdi'
        })
      }
      // Devuelve el valor correspondiente para continuar con los steps o nó
      return resultadoValidacion
    },
    // Deja continuar solo si se cargó alguna foto
    validacionTabFotos () {
      let validacion = {
        error: false,
        message: ''
      }

      // Si no cargo al menos una foto, ya hay error
      if (!this.existenFotosSeleccionadas()) {
        validacion = {
          error: true,
          message: 'Debe cargar al menos una foto para poder subir el pedido.'
        }
      } else {
        switch (this.tipoSubida) {
          case this.$constantes.tiposSubida.PACK_FOTO: // Varias variantes
            switch (this.packFoto.oferta.tipoPackFoto) {
              case this.$constantes.ofertas.tiposPackFotos.MIN_MAX_FIJO:
                if (this.cantidadMinimaNoAlcanzada) {
                  validacion = {
                    error: true,
                    message: `Para este tipo de pedido se deben subir al menos ${this.packFoto.cantidadMinFotos} fotos. Cargá algunas más.`
                  }
                } else if (this.cantidadMaximaExcedida) {
                  validacion = {
                    error: true,
                    message: `Para este tipo de pedido se deben subir máximo ${this.packFoto.cantidadMaxFotos} fotos. Eliminá algunas e intenta nuevamente.`
                  }
                }
                break
              case this.$constantes.ofertas.tiposPackFotos.MIN_MAX_POR_UNIDAD:
                if (this.cantidadMinimaNoAlcanzada) {
                  validacion = {
                    error: true,
                    message: `Para este tipo de pedido se deben subir al menos ${this.packFoto.cantidadMinFotos} fotos. Cargá algunas más.`
                  }
                } else if (this.cantidadMaximaExcedida) {
                  validacion = {
                    error: true,
                    message: `Para este tipo de pedido se deben subir máximo ${this.packFoto.cantidadMaxFotos} fotos. Eliminá algunas e intenta nuevamente.`
                  }
                }
                break
              case this.$constantes.ofertas.tiposPackFotos.FIJO:
                if (this.cantidadMinimaNoAlcanzada || this.cantidadMaximaExcedida) {
                  validacion = {
                    error: true,
                    message: `Para este tipo de pedido se deben subir exactamente ${this.packFoto.cantidadMinFotos} fotos. Revisá el total.`
                  }
                }
                break
            }
            break
          case this.$constantes.tiposSubida.OFERTA: // Pedido con pack foto dinamico
            // Por ahora ninguna validacion extra a que suba al menos una foto
            break
        }
      }

      if (validacion.error) {
        this.$buefy.dialog.alert({
          title: 'Error',
          message: validacion.message,
          type: 'is-danger',
          hasIcon: true,
          icon: 'close-circle-outline',
          iconPack: 'mdi'
        })
        return false
      } else {
        return true
      }
    },
    // Chequea si existen  fotos seleccionadas
    existenFotosSeleccionadas () {
      return this.cantidadFotosSeleccionadas > 0
    }
  },
  created () {
    this.tipoUsuario = this.$VueJwtDecode.decode(
      localStorage.getItem('jwt')
    ).tipo
    // Recupera datos del usuario
    const componenteVue = this

    // Solo recupera el precio del cadete si el usuario es aficionado
    if (this.tipoUsuario === this.$constantes.usuarios.tipos.AFICIONADO) {
      this.$apiService
        .getCadetes()
        .then(response => {
          componenteVue.wizard.cadete = response.data['hydra:member'][0]
        })
        .catch(error => {
          componenteVue.mensajeErrorAxios(error, componenteVue)
        })
    }
  },
  mounted () {
    // Recupero variable de plupload desde contexto de VUE
    const plupload = this.$plupload

    // Referencio al componente actual para poder usarlo en funciones anidadas
    const componenteVue = this

    // Variables para manejos en javascript
    const token = this.generarToken()

    // Obtiene el jwt
    const jwt = localStorage.getItem('jwt')

    // Crea el uploader
    const uploader = new plupload.Uploader({
      browse_button: 'buscar-fotos',
      drop_element: 'drop-target',
      headers: {
        Authorization: 'Bearer ' + jwt
      },
      url: process.env.VUE_APP_URL_API + process.env.VUE_APP_URL_API_UPLOAD,
      multipart_params: { token: token }, // Agrega el token que se genera por usuario-pestaña (Es decir, si el usuario abre dos pestañas genera dos subidas diferentes)
      filters: {
        mime_types: [
          { title: 'Archivos de Imagen', extensions: 'jpg,jpeg,png,gif,bmp' }
        ],
        prevent_duplicates: true // no permite agregar funciones duplicadas
      },
      max_file_size: `${process.env.VUE_APP_MAX_FILE_SIZE}mb`,
      max_retries: 5
    })

    // Agrega funcion para ejecutar cuando termina la subida de fotos
    uploader.bind('UploadComplete', function (up, files) {
      componenteVue.uploadComplete()
    })

    // Recibe el ID de pedido creado desde el backend
    uploader.bind('FileUploaded', (up, file, result) => {
      // Guarda el id del pedido en el caso de que aun no se haya almacenado localmente
      if (!componenteVue.idPedidoCreado) {
        const datos = JSON.parse(result.response)
        componenteVue.idPedidoCreado = datos.idPedido
      }
    })

    // Muestra los errores por pantalla y guarda lista de archivos con error
    uploader.bind('Error', (up, error) => {
      if (error.code === componenteVue.$plupload.HTTP_ERROR) {
        // Agrega el archivo al array de archivos con error
        const archivoErroneo = {
          archivo: error.file,
          response: error.response,
          status: error.status
        }
        componenteVue.archivosErroneos.push(archivoErroneo)
      }

      // Muestra un mensaje con el error
      componenteVue.$buefy.toast.open({
        duration: 1500,
        message: `${error.message}`,
        position: 'is-top',
        type: 'is-danger'
      })
    })

    // Agrega funcion para modificar el target del drop y mostrar efecto
    uploader.bind('Init', function (up, params) {
      if (uploader.features.dragdrop) {
        var target = document.getElementById('drop-target')

        target.ondragover = function (event) {
          event.dataTransfer.dropEffect = 'copy'
        }

        target.ondragenter = function () {
          this.className = 'dragover'
        }

        target.ondragleave = function () {
          this.className = ''
        }

        target.ondrop = function () {
          this.className = ''
        }
      }
    })

    // Agrega funcion para notificaciones en envios gratis
    uploader.bind('QueueChanged', up => {
      this.cantidadFotosSeleccionadas = uploader.files.length
      this.evaluarNotificacionEnvioGratis(up)
    })

    this.uploader = uploader

    this.uploader.init()

    // Controla si el token tiene el tiempo minimo necesario para una subida de fotos tradicional
    this.controlarVencimientoToken()
  }
}
</script>
